// Hiding and showing login and register forms on checkout login

// Toggle login vs make an account in login step
export function loginToggle() {
    jQuery(".toggler").click(function (e) {
        // prevent the page from reloading on click
        e.preventDefault()
        //
        jQuery(".hideorshow").toggle();
    });
}

// Toggle password show hide
export function passwordToggle() {
    jQuery(".toggle-password").click(function () {
        jQuery(this).toggleClass("fa-eye fa-eye-slash");
        var input = jQuery(jQuery(this).attr("toggle"));
        if (input.attr("type") == "password") {
            input.attr("type", "text");
        } else {
            input.attr("type", "password");
        }
    });
}

// Toggle between list and map view for the mobile ffl modal
export function fflToggle() {
    jQuery('.search-toggler').click(function (e) {
        // prevent the page from reloading on click
        e.preventDefault();
        jQuery('.ffl-map-wrapper').toggle();
        jQuery('.ffl-list-wrapper').toggle();

    });
}

// Simple Toggle Using Data Elements
export function simpleToggle() {
    jQuery("a[data-toggle]").click(function (e) {
        // console.log('data toggle clicked mhmm');
        e.preventDefault(); // prevent navigating
        var selector = jQuery(this).data("toggle"); // get corresponding selector from data-toggle
        jQuery(selector).toggle();
    });
}

// Dark and Light Header Toggle 
export function headerColorToggle() {
    var toggled = false;
    jQuery('input.color-toggle').click(function () {
        toggled = !toggled;
        jQuery('#header-container').toggleClass('header-container-light header-container-dark');
        jQuery('.rootmenu-mobile').toggleClass('rootmenu-mobile-light rootmenu-mobile-dark');
        jQuery('#header .logo img.logo-desktop').attr('src', toggled ? '/skin/frontend/default/classic-arms-19/images/svg/classic-vert-logo-dark-svg.svg' : '/skin/frontend/default/classic-arms-19/images/svg/classic-vert-logo-svg.svg');
        jQuery('#header .logo img.logo-scroll').attr('src', toggled ? '/skin/frontend/default/classic-arms-19/images/svg/classic-horiz-scroll-logo-dark-svg.svg' : '/skin/frontend/default/classic-arms-19/images/svg/classic-horiz-scroll-logo-svg.svg');
        jQuery('#header .logo-mobile img').attr('src', toggled ? '/skin/frontend/default/classic-arms-19/images/svg/classic-horiz-scroll-logo-dark-svg.svg' : '/skin/frontend/default/classic-arms-19/images/svg/classic-horiz-scroll-logo-svg.svg');
    });
}